import { render, staticRenderFns } from "./LazyBackground.vue?vue&type=template&id=6ef8bb80&scoped=true&"
import script from "./LazyBackground.vue?vue&type=script&lang=js&"
export * from "./LazyBackground.vue?vue&type=script&lang=js&"
import style0 from "./LazyBackground.vue?vue&type=style&index=0&id=6ef8bb80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8bb80",
  null
  
)

export default component.exports